<template>
  <widgetModal
    :title="questionnaire.title"
    :subtitle="
      questionnaire.user
        ? 'Created by ' +
          questionnaire.user.first_name +
          ' ' +
          questionnaire.user.last_name
        : ''
    "
    btnlefttext=""
    btncentertext="Close"
    btnrighttext=""
    :leftloading="false"
    :rightloading="false"
    :centerloading="false"
    :footerhidden="false"
    footer_padding="20px 20px"
    header_padding="20px 0px 0px 20px"
    body_padding="0px 20px"
    width="580px"
    @onCenterClick="onCancel"
  >
    <div class="student-profile-widget">
      <widgetProfile
        :title="student.first_name + ' ' + student.last_name"
        :subtitle="student.profile ? student.profile.address : ''"
        :file_name="student.profile_picture"
        :path="$fullUrl('images/profiles/')"
      ></widgetProfile>
    </div>
    <div class="widget-modal-body-noscoll">
      <div class="users-answer-body-right-body">
        <template v-for="(item, index) in result">
          <div
            class="survey-answer-widget"
            :key="index"
            v-if="item.section_type == 'question'"
          >
            <div class="survey-answer-header">
              <h1>{{ item.ask }}</h1>
            </div>
            <!-- For short answer -->
            <div
              v-if="item.question_type == 'short_answer'"
              class="survey-answer-body"
            >
              {{ item.answer }}
            </div>
            <!-- For long answer -->
            <div
              v-if="item.question_type == 'paragraph'"
              class="survey-answer-body"
            >
              {{ item.answer }}
            </div>
            <!-- For radio answer -->
            <div
              v-if="item.question_type == 'multiple_choice'"
              class="survey-answer-body"
            >
              <div
                class="radio-item"
                v-for="(option, option_index) in item.choice_options"
                :key="option_index"
                :class="{ active: item.answer == option.value }"
              >
                <span>{{ option.name }}</span>
              </div>
            </div>
            <!-- For checkbox answer -->
            <div
              v-if="item.question_type == 'checkboxes'"
              class="survey-answer-body"
            >
              <div
                class="checkbox-item"
                v-for="(option, option_index) in item.choice_options"
                :key="option_index"
                :class="{ active: option.value }"
              >
                <span>{{ option.name }}</span>
              </div>
            </div>
            <!-- For checkbox answer -->
            <div
              v-if="item.question_type == 'dropdown'"
              class="survey-answer-body"
            >
              <div
                class="selected-item"
                v-for="(option, option_index) in item.choice_options"
                :key="option_index"
                v-if="option.value == item.answer"
              >
                <span>{{ option.name }}</span>
              </div>
            </div>
            <!-- For file upload answer -->
            <div
              v-if="item.question_type == 'file_upload'"
              class="survey-answer-body"
            >
              <div class="uploaded-file-item">
                <img
                  v-if="$isImage(item.file_name)"
                  :src="$fullUrl('images/' + item.file_name)"
                  width="100%"
                />
                <video
                  v-if="$isVideo(item.file_name)"
                  :src="$fullUrl('images/' + item.file_name)"
                  width="100%"
                />
                <a
                  v-if="!$isVideo(item.file_name) && !$isImage(item.file_name)"
                  :download="$fullUrl('images/' + item.file_name)"
                  class="btn-download"
                  :href="$fullUrl('images/' + item.file_name)"
                  >Download file</a
                >
              </div>
            </div>
            <!-- For date answer -->
            <div v-if="item.question_type == 'date'" class="survey-answer-body">
              <div class="date-item">
                {{ item.answer | formatDate }}
              </div>
            </div>
            <!-- For date answer -->
            <div v-if="item.question_type == 'time'" class="survey-answer-body">
              <div class="date-item">
                {{ item.answer }}
              </div>
            </div>
          </div>
          <div
            class="survey-answer-widget"
            :class="{ section_widget: item.section_type == 'section' }"
            :key="index"
            v-if="item.section_type == 'section'"
            @click="selectSurvey(item)"
          >
            <h1>{{ item.title }}</h1>
            <p>{{ item.description }}</p>
          </div>
          <div
            class="survey-answer-widget"
            :class="{ title_widget: item.section_type == 'title' }"
            :key="index"
            v-if="item.section_type == 'title'"
          >
            <h2>{{ item.title }}</h2>
            <p>{{ item.description }}</p>
          </div>
        </template>
      </div>
    </div>
  </widgetModal>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    result: {
      type: Array,
      default: () => [],
    },
    student: {
      type: Object,
      default: null,
    },
    questionnaire: {
      type: Object,
      default: null,
    },
  },
  data: () => {
    return {};
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";
.users-answer-body-right-body {
  overflow-y: auto;
  height: calc(100% - 60px);
  padding: 0px 0px;
  margin-top: 20px;
  .survey-answer-widget {
    border-bottom: 1px solid #ddd;
    margin-bottom: 20px;

    &.section_widget {
      border-bottom: 3px solid #ddd;

      h1 {
        font-size: 20px;
      }
    }

    &.title_widget {
      h2 {
        font-size: 18px;
      }

      p {
        font-size: 13px;
      }
    }

    .survey-answer-header {
      h1 {
        font-size: 16px;
        color: #000;
      }
    }

    .survey-answer-body {
      color: rgb(43, 42, 42);

      .radio-item {
        margin-bottom: 6px;

        &.active {
          color: #0884af;
          padding: 4px;
          border-left: 3px solid #0884af;
        }
      }

      .checkbox-item {
        margin-bottom: 6px;

        &.active {
          color: #0884af;
          padding: 4px;
          border-left: 3px solid #0884af;
        }
      }

      .uploaded-file-item {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;

        .btn-download {
          background: #0884af;
          color: #fff;
          padding: 11px;
          border-radius: 5px;
          text-decoration: none;
          text-align: center;
        }
      }
    }
  }
}
</style>


